import React from 'react';

export default function Services() {
  const services = [
    {
      icon: 'ri-hand-heart-line',
      title: 'Manual Therapy',
      description: 'Hands‑on treatment techniques to improve mobility, reduce pain, and restore function through skilled manipulation and mobilization.',
      image: 'https://public.readdy.ai/ai/img_res/edited_92d340867856402ec0e37b9ea8c5a081_9ed28ed7.jpg',
    },
    {
      icon: 'ri-football-line',
      title: 'Sports Injury Rehabilitation',
      description: 'Specialized treatment programs for athletes to recover from injuries and return to peak performance safely.',
      image: 'https://readdy.ai/api/search-image?query=male%20physiotherapist%20eyes%20open%20alert%20helping%20young%20male%20athlete%20stretch%20leg%20on%20treatment%20table%20sports%20rehabilitation%20bright%20gym%20clinic%20setting%20white%20background%20natural%20light%20professional%20focused%20expression%20both%20people%20eyes%20fully%20open&width=600&height=780&seq=svc_sports_2025&orientation=portrait',
    },
    {
      icon: 'ri-surgical-mask-line',
      title: 'Post‑Surgical Rehabilitation',
      description: 'Comprehensive recovery programs designed to help you regain strength, mobility, and confidence after surgery.',
      image: 'https://public.readdy.ai/ai/img_res/edited_26569f91494ba86ecd3edd8ae11f8802_8a4a5f99.jpg',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Chronic Pain Management',
      description: 'Evidence‑based approaches to manage and reduce long‑term pain conditions, improving your quality of life.',
      image: 'https://readdy.ai/api/search-image?query=female%20physiotherapist%20with%20open%20eyes%20and%20warm%20smile%20placing%20hands%20on%20middle%20aged%20patient%20shoulders%20during%20pain%20relief%20session%20modern%20bright%20physiotherapy%20clinic%20large%20windows%20daylight%20airy%20white%20interior%20professional%20wellness%20care&width=600&height=780&seq=pain_mgmt_v3_fix&orientation=portrait',
    },
    {
      icon: 'ri-run-line',
      title: 'Movement Assessment',
      description: 'Detailed analysis of your movement patterns to identify imbalances and develop corrective exercise programs.',
      image: 'https://readdy.ai/api/search-image?query=physiotherapist%20using%20clipboard%20to%20assess%20young%20woman%20performing%20single%20leg%20squat%20movement%20screen%20in%20bright%20open%20physio%20studio%20white%20walls%20wooden%20floor%20natural%20sunlight%20professional%20clinical%20evaluation%20both%20people%20eyes%20open%20attentive&width=600&height=780&seq=movement_assess_v4_new&orientation=portrait',
    },
    {
      icon: 'ri-government-line',
      title: 'Medicare & NDIS Physiotherapy',
      description: 'Fully registered for Medicare and NDIS plans — making quality physiotherapy accessible and affordable for all eligible patients.',
      image: 'https://readdy.ai/api/search-image?query=friendly%20physiotherapist%20eyes%20wide%20open%20smiling%20warmly%20with%20NDIS%20medicare%20patient%20in%20bright%20welcoming%20clinic%20room%20both%20people%20eyes%20fully%20open%20happy%20engaged%20supportive%20inclusive%20healthcare%20professional%20natural%20light%20clean%20white%20modern%20setting&width=600&height=780&seq=svc_ndis_2025&orientation=portrait',
    },
  ];

  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    (e.currentTarget as HTMLImageElement).src = 'https://via.placeholder.com/600x780?text=Image+unavailable';
  };

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 mb-4">
            <div className="w-3 h-3 bg-teal-700 transform rotate-45"></div>
            <span className="text-teal-700 font-semibold tracking-wider uppercase text-sm">Our Services</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Georgia, serif' }}>
            Comprehensive Physiotherapy Solutions
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="relative rounded-3xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
              style={{ height: '520px' }}
            >
              <img src={service.image} alt={service.title} onError={handleImgError} className="w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <div className="w-12 h-12 rounded-full bg-teal-600/80 flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold mb-3">{service.title}</h3>
                <p className="text-white/90 leading-relaxed text-sm">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
